"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
var portal_1 = require("../portal");
/** Render some content in a menu fixed to the top of the screen */
var Header = function (_a) {
    var className = _a.className, children = _a.children, portalTo = _a.portalTo, shouldPortal = _a.shouldPortal, portalToSelector = _a.portalToSelector, htmlProps = tslib_1.__rest(_a, ["className", "children", "portalTo", "shouldPortal", "portalToSelector"]);
    var content = (React.createElement("header", tslib_1.__assign({ className: utils_1.ClassNames.concat('arm-header', className) }, htmlProps), children));
    if (!shouldPortal) {
        return content;
    }
    return (React.createElement(portal_1.Portal, { portalTo: portalTo, portalToSelector: portalToSelector }, content));
};
exports.Header = Header;
exports.Header.defaultProps = {
    shouldPortal: true,
};
